import React from "react";
import { Table } from "antd";
import moment from "moment";
import { IconDelete, IconEdit } from "../../../../common/ui/icons";
import TablePageSize from "./TablePageSize";

const PersonTable = ({
  data,
  onChange,
  loading,
  deletePersonFromList,
  changePageSize,
  editPerson,
  personTypeKey
}) => {
  const columns = [
    {
      title: "ФИО",
      dataIndex: "fio",
      key: "fio",
      sorter: true
    },
    personTypeKey === "children"
      ? {
          title: "Д.р.",
          key: "birthDate",
          sorter: true,
          render: row => {
            const birthDate =
              (row.birth_date && moment(row.birth_date).format("DD.MM.YYYY")) ||
              "—";
            return (
              <div>
                <div>{birthDate}</div>
              </div>
            );
          }
        }
      : {
          title: "Д.р./Пол",
          key: "sex",
          sorter: true,
          render: row => {
            const birthDate =
              (row.birth_date && moment(row.birth_date).format("DD.MM.YYYY")) ||
              "—";
            const gender = (row.sex && row.sex.sex) || "—";
            return (
              <div>
                <div>{birthDate}</div>
                <div>{gender}</div>
              </div>
            );
          }
        },
    {
      title: "Телефон",
      // sorter: true,
      key: "phone",
      render: row => {
        return (
          <div>
            {row.phone_code && row.phone_number
              ? `${row.phone_code}${row.phone_number}`
              : "—"}
          </div>
        );
      }
    },
    personTypeKey === "children"
      ? {}
      : {
          title: "Документ",
          key: "document",
          // sorter: true,
          render: row => {
            const document =
              row.identity_document &&
              row.identity_document.identity_document_name;
            const series = row.identity_document_series;
            const num = row.identity_document_num;
            return (
              <div>
                <div>{document || "—"}</div>
                <div>{(series && num && `${series} ${num}`) || "—"}</div>
              </div>
            );
          }
        },
    {
      dataIndex: "person_id",
      render: person_id => {
        return (
          <div style={{ minWidth: "64px" }}>
            <IconEdit
              style={{ color: "#00A8FF", marginRight: 16 }}
              onClick={() => {
                editPerson({ person_id, personTypeKey });
              }}
            />
            <IconDelete
              style={{ color: "#F5222D" }}
              onClick={() => {
                deletePersonFromList({ person_id, personTypeKey });
              }}
            />
          </div>
        );
      }
    }
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data.data}
        className={"person-table"}
        rowKey={"person_id"}
        onChange={onChange}
        loading={loading}
        locale={{
          emptyText:
            personTypeKey === "children"
              ? "Дети не добавлены"
              : personTypeKey === "attendants"
              ? "Сопровождающие не добавлены"
              : personTypeKey === "shippingorg"
              ? "Работники и/или физ. лица не добавлены"
              : personTypeKey === "med"
              ? "Мед. работники не добавлены"
              : " Пассажиры не добавлены"
        }}
        pagination={{
          pageSize: data ? data.per_page : 0,
          total: data ? data.total : 0,
          current: data ? data.current_page : 0
        }}
      />
      {data && data.data && data.data.length > 0 && (
        <TablePageSize
          changePageSize={changePageSize}
          pages={data ? data.per_page : 0}
        />
      )}
    </>
  );
};

export default PersonTable;
